import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';

const APP_NAME = 'DoctorCity Member';

@Injectable({ providedIn: 'root' })
export class DcTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    if (routeTitle) {
      this.title.setTitle(`${routeTitle} — ${APP_NAME}`);
    } else {
      this.title.setTitle(APP_NAME);
    }
  }
}
